export const generateBoxAnalysisPayload = (selectedOptions) => {
    return Object.fromEntries(
        Object.entries(selectedOptions)
            .map(([key, value]) => {
                const transformed = {
                    ...(value.top_box ? { top: value.top_box.value } : {}),
                    ...(value.bottom_box ? { bottom: value.bottom_box.value } : {}),
                };
                return Object.keys(transformed).length > 0 ? [key, transformed] : null;
            })
            .filter(Boolean) // remove nulls (empty objects)
    );
};

export const generateBoxAnalysisPayloadBySelection = (selectedOptions, key) => {
    const _boxAnalysis = generateBoxAnalysisPayload(selectedOptions);
    return Object.fromEntries(Object.entries(_boxAnalysis).map(([k, v]) => [k, { [key]: v[key] }]));
};
